
<template>
  <div
      class="landingImage"
      :style="{ backgroundImage: `url(${homepageStore.heroImageUrl})` }"
  >
    <div class="container hero-container items-center flex flex-col h-full justify-center">
      <div class="booking__subtitle font-semibold responsive-title-3 mb-6 ml-3">
        {{ t('booking.subtitle') }}
      </div>
      <div class="booking-component-container w-6/12 min-w-[885px]  h-[10%] sm:h-1/5 z-40">

        <BookingComponent />
      </div>
    </div>
  </div>
</template>


<script setup lang="ts">
import { onMounted } from "vue";
import { useI18n } from "vue-i18n";
import BookingComponent from "@/components/BookingComponent/BookingComponent.vue";
import { useHomepageStore } from "@/stores/homepageStore";

const { t } = useI18n();
const homepageStore = useHomepageStore(); 

onMounted(() => {
  homepageStore.fetchHomepageData();
});
</script>


<style scoped>
.need-help__crew-imgs img {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  border: 3px solid white;
}

.need-help__crew-imgs img:not(:first-child) {
  margin-left: -15px !important;
}

.thirddiv-join__cta .tag-pills div {
  height: 30px;
}



.landingImage {
  background-size: cover;
  background-position: center;
  max-height: 650px;
  height: 65vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: white;
  gap: 40px;
}




.grid-container {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(2, 1fr);
  gap: 20px;
}

.grid-item {
  position: relative;
  overflow: hidden;
  border-radius: 8px;
  height: 200px;
}

.grid-item.large {
  grid-column: span 2;
}

.grid-item img {
  width: 100%;
  height: 100%;
  object-fit: cover; /* Ensure images cover the item area */
}

.grid-item .content {
  position: absolute;
  bottom: 10px;
  left: 10px;
  color: white;
  padding: 10px;
  border-radius: 4px;
}

.newsOverflow {
  overflow-x: scroll;
  gap: 20px;
  display: flex;
  width: 90vw;
}

.textboxContainer .textbox {
  width: 400px;
}

@media (min-width: 1679px) {
  .imagePlaceholder {
    height: 65px;
  }
}

@media (max-width: 1678px) {
  .landingImage .booking__title {
    width: 50%;
  }

  .thirddiv {
    row-gap: 40px;
  }

  .thirddiv .need-help {
    row-gap: 25px;
  }

  .thirddiv .textbox__title {
    font-size: 16px;
  }

  .thirddiv .textbox__subtitle {
    font-size: 14px;
  }

  .thirddiv .thirddiv-join__cta h2 {
    font-size: 40px !important;
  }

  .textboxContainer .textbox {
    width: 20vw;
  }

}

@media (max-width: 1735px) {
  .whychoose-cards {
    height: 19vw;
    width: 20vw;
  }
}

@media (max-width: 1538px) {
  .section-title__header {
    font-size: 2.5rem;
  }

  .cardcolor__title-body {
    font-size: 1rem;
  }

  .whychoose-cards {
    height: 21vw;
    width: 22vw;
  }

  .loyalty-row .imagePlaceholder {
    width: 3vw;
  }

  .custom-centri-row .imagePlaceholder {
    width: 5vw;
  }

  .integrity-row .imagePlaceholder {
    width: 4vw;
  }

  .reliability-row .imagePlaceholder {
    width: 6vw;
  }

  .whychoose-grid .spanNumber {
    font-size: 18px;
  }

  .whychoose-grid .cardcolor__text {
    font-size: 14px;
  }
}

@media (max-width: 1400px) {
  .seconddiv {
    padding-top: 24px;
    padding-bottom: 24px;
  }
}

@media (max-width: 1440px) and (min-width: 1025px) {
  .seconddiv {
    width: 65%;
  }

  .need-help__crew-imgs img {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    border: 3px solid white;
  }

  .cardcolor {
    width: 22vw;
    height: 21vw;
  }

  .cardcolor__body {
    font-size: 14px;
  }
}

@media (max-width: 1350px) {
  .section-title__header {
    font-size: 34px;
  }

  .cardcolor__title-body {
    font-size: 14px;
  }

  .cardcolor.cardcolor__title {
    height: 300px !important;
  }


  .travel-inspirations__grid.mobile-travel img {
    width: 30vw;
  }
}

@media (max-width: 1269px) {
  .whychoose-cards {
    height: 25vw;
  }
}

@media (max-width: 1155px) and (min-width: 581px) {
  .landingImage .booking__title {
    width: 70%;
  }

  .seconddiv {
    width: 100% !important;
  }

  .thirddiv {
    flex-direction: column;
  }

  .thirddiv-join__cta {
    width: 100%;
  }

  .thirddiv .textboxContainer {
    gap: 30px;
  }

  .thirddiv-join__cta {
    width: 100%;
  }

  .whychoose-cards {
    height: 26vw;
  }
}

@media (max-width: 1155px) {
  .textboxContainer .textbox {
    width: unset;
  }

  .need-help-desktop__icons {
    display: none;
  }

  .grid-container {
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(4, 1fr);
  }

  .grid-item.large {
    grid-column: unset;
  }
}

@media (min-width: 1155px) {
  .phone {
    display: none;
  }

  .thirddiv-join__cta {
    width: 400px;
  }

  .phone-crew {
    display: none;
  }
}

@media (max-width: 1280px) {
  .landingImage .booking__title {
    font-size: 44px;
  }

  .seconddiv .icon-box {
    flex-direction: column;
  }

  .icon-box__title,
  .icon-box__subtitle {
    text-align: center;
  }

  .seconddiv img {
    width: 55px;
  }

  .curatedContainer .curated-container__title {
    font-size: 18px;
  }

  .charter__title {
    font-size: 18px;
  }

  .whychoose-cards {
    align-content: center !important;
  }
}

@media (max-width: 1070px) {
  .whychoose-grid {
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(3, 1fr);
    grid-template-rows: inherit;

    column-gap: 1.5rem;
    row-gap: 2.5rem;
  }

  .whychoose-grid .whychoose-cards-top {
    display: flex;
    column-gap: 1rem;
  }

  .why-choose-row {
    grid-area: 1 / 1 / 2 / 3;
    justify-content: start !important;
  }

  .whychoose-cards {
    width: 100%;
    //padding: 0 !important;
    padding-right: 55px;
    padding-left: 55px;
  }

  .integrity-row {
    grid-area: 2 / 1 / 3 / 2;
    width: inherit;
  }

  .custom-centri-row {
    grid-area: 2 / 2 / 3 / 3;
    width: inherit;
  }

  .loyalty-row {
    grid-area: 3 / 1 / 4 / 2;
    width: inherit;
  }

  .reliability-row {
    grid-area: 3 / 2 / 4 / 3;
    width: inherit;
  }

  .cardcolor__title {
    width: 55%;
  }

  .section-title__header {
    font-size: 3.5rem;
  }
}

@media (max-width: 975px) {
  .booking-component-container {
    width: 100%;
    min-width: unset !important;
  }

  .whychoose-cards {
    padding-right: 35px;
  }
}

@media (max-width: 900px) {
  .cardcolor__title {
    font-size: 20px;
  }

  .cardcolor__body {
    font-size: 1rem;
  }
}

@media (min-width: 786px) {
  .desktop-flex {
    display: flex;
  }

  .desktop {
    display: block;
  }

  .phone {
    display: none;
  }

  .phone-flex {
    display: none;
  }

}

@media (max-width: 785px) {
  .whyScroll {
    overflow-x: scroll;
    gap: 20px;
    display: flex;
  }

  .whyScroll .whychoose-cards {
    height: 100%;
  }

  .cardcolor {
    min-width: 320px;
    height: 300px;
    position: relative;
  }

  .loyalty-row {
    display: none;
  }

  .custom-centri-row {
    display: none;
  }

  .integrity-row {
    display: none;
  }

  .reliability-row {
    display: none;
  }

  .section-title__header {
    font-size: 2.75rem;
  }

  .hero-container {
    row-gap: 1.25rem;
  }
}

@media (max-width: 768px) {
  .landingImage {
    max-height: 474px;
    background-position: center;
  }

  .booking__subtitle {
    display: none;
  }

  .landingImage .booking__title {
    width: 85%;
    background-position: center;
  }

  .seconddiv img {
    width: 45px;
  }
  

  .thirddiv {
    row-gap: 36px;
  }

  .imageCol {
    width: 100%;
    height: auto;
    object-fit: cover;
  }

  .whitespace {
    max-height: 55px;
  }

  .curatedContainer .grid-container {
    display: flex !important;
    overflow-x: scroll;
  }

  .curatedContainer .grid-item {
    min-width: 260px;
    height: 300px;
  }

  .curatedContainer {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .headerCharter {
    font-size: 44px;
  }

  .charterContainer > div > div {
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }

  .desktop,
  .desktop-flex {
    display: none;
  }

  .phone {
    display: block;
  }

  .phone-flex {
    display: flex;
  }

  .thirddiv {
    padding-top: 50px;
    padding-bottom: 50px;
    flex-direction: column;
  }


  .bluediv {
    padding: 20px;
  }

  .bluediv > div {
    flex-direction: column;
    gap: 20px;
    padding: 30px 20px;
    height: 100%;
  }

  .sub {
    width: fit-content;
  }

  .textbox > .font-bold {
    font-size: 14px;
  }

  .textbox > .textBGgreen {
    font-size: 12px;
    width: 150px;
  }

  .textboxContainer {
    flex-direction: row;
    flex-wrap: wrap;
    max-width: 90vw;
  }

  .emailSub {
    height: 64px;
  }
}

@media (min-width: 1155px) {

}

@media (max-width: 580px) {
  .landingImage .booking__subtitle {
    display: none;
  }

  .seconddiv {
    flex-direction: column;
    align-items: center;
    row-gap: .65rem;
  }

  .seconddiv .icon-box {
    flex-direction: row;
    justify-content: unset !important;
    align-items: center;
    width: 100%;
    column-gap: 2rem;
  }
  
  .textbox .textbox__title {
    font-size: 16px !important;
  }

  .textbox .textbox__subtitle {
    font-size: 14px !important;
  }

  .thirddiv {
    row-gap: 36px;
  }

  .section-title__header {
    font-size: 1.875rem;
  }
}

@media (max-width: 480px) {
  .grid-container {
    grid-template-columns: 1fr;
  }
}
</style>